/*
 * - Definitions for Project queries
 */

import ProjectService from './service';
import {
  GetSharedContactResponseData,
  GetExistingProjectsResponseData,
  GetProjectLocationResponseData,
  GetAllowedRequestTypesResponseData,
} from './types';

export const PROJECT_QUERY_KEYS = {
  GET_SHARED_CONTACTS: 'GET_SHARED_CONTACTS',
  GET_EXISTING_PROJECT: 'GET_EXISTING_PROJECT',
  GET_PROJECT_LOCATION: 'GET_PROJECT_LOCATION',
  GET_ALLOWED_REQUEST_TYPES: 'GET_ALLOWED_REQUEST_TYPES',
};

export class ProjectQueries {
  public static readonly getSharedContacts = async (
    projectId: number,
    requestId: number,
    version: number
  ): Promise<GetSharedContactResponseData> => {
    const { data } = await ProjectService.getSharedContacts(projectId, requestId, version);

    return data;
  };

  public static readonly getExistingProjectsBasicInfo = async (): Promise<GetExistingProjectsResponseData> => {
    const { data } = await ProjectService.getExistingProjectsBasicInfo();
    return data;
  };

  public static readonly getProjectLocationData = async (
    projectId: number,
    projectVersion?: number
  ): Promise<GetProjectLocationResponseData> => {
    const { data } = await ProjectService.getProjectLocationData(projectId, projectVersion);
    return data;
  };

  public static readonly getAllowedRequestTypes = async ({
    state,
    district,
  }: {
    state?: string;
    district?: string;
  }): Promise<GetAllowedRequestTypesResponseData> => {
    const { data } = await ProjectService.getAllowedRequestTypes({
      state,
      district,
    });
    return data;
  };
}
